import ProductsDesktop from './ProductsDesktop';

export default ProductsDesktop;
